<template>
  <v-layout fill-height column>
    <v-container flex-fill>
      <div class="question pt-9 pb-10" v-html="ques[0]"></div>
      <div class="thermometer">
        <v-slider
            v-model="emotionValue"
            step="10"
            vertical
            tick-size="4"
            class="slider"
            :color="selectEmotion.color"
            track-color="transparent"
            :readonly="first||cmplt"
        ></v-slider>
        <div
            class="num-area"
            :style="{ backgroundColor: selectEmotion.color }"
            @click="reset"
        >
          <span class="num">{{ emotionValue }}</span>
        </div>
        <ThermometerIcon />
        <v-btn v-if="!cmplt"  plain :ripple="false" :style="{backgroundColor:bgColor}" class="emotion-text" @click="sheet = true">{{ selectEmotion.value}}<img :src="getImage('ic_down_arrow.svg')" class="ml-2"></v-btn>
        <v-btn v-else plain :ripple="false" :style="{backgroundColor:bgColor}" class="emotion-text">{{ selectEmotion.value}}<img :src="getImage('ic_down_arrow.svg')" class="ml-2"></v-btn>
        <!-- <v-btn plain :ripple="false" :style="{backgroundColor:selectEmotion.color}" class="emotion-text" @click="sheet = true">{{ selectEmotion.value}}<img :src="getImage('ic_down_arrow.svg')" class="ml-2"></v-btn> -->
      </div>
      <EmotionSheet :sheet="sheet" :emotionStrArr="emotionList" :maxSelect="maxSelect" :answer="answer" @emotionSelected="emotionSelected" @close="sheetClose"/>
    </v-container>
    <FooterBtnsNext  @before="$emit('before')" @next="setMemberReply" :current="current" :total="total" :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import FooterBtnsNext from "@/components/btns/FooterBtnsNext";
import ThermometerIcon from "@/components/icons/Thermometer";
import EmotionSheet from "@/components/layout/bottomSheet/EmotionSheet";
import store from '../../../store'
export default {
  props:["current","total","unitUseNo","unitDtlUseList","freeYn","cmpltYn","unitDtlUseNo","unitDtlPageSeq"],
  data: () => ({
    sheet:false,
    first:true, /* 처음 진입 */
    // question: "질문질문질문질문질문질문질문질문질 문질문질문질문질문질문질문?",

    emotionValue: 0,
    // emotionStrArr: [
    //     {title:'행복한',color:'#FFCA19',value:['기쁜', '행복한','뿌듯한','고마운','편안한','유쾌한','희망찬','들뜬','보람찬','신난','열정적인']},
    //     {title:'화난',color:'#FF6019',value:['화난','못마땅한','열받은','억울한','불쾌한','미운','속상한','짜증난','답답한','욱하는','원망스러운']},
    //     {title:'두려운',color:'#19ffd9',value:['불안한','긴장되는','걱정스러운','불편한','조바심 나는','두려운','어쩔 줄 모르는','스트레스 받는','압박감 느끼는','부담스러운','조심스러운']},
    //     {title:'슬픈',color:'#1962ff',value:['아쉬운','안타까운','슬픈','서러운','그리운','마음 아픈','외로운','울고 싶은','가여운','불쌍한','애틋한']},
    //     {title:'수치심 느끼는',color:'#ff1990',value:['수치심 느끼는','열등감 느끼는','한심한','죄책감 느끼는','뻘쭘한','반복해서 생각나는','혼란스러운','무안한','당황스러운','시선이 의식되는','부끄러운']},
    //     {title:'우울한',color:'#000',value:['실망한','마음이 무거운','괴로운','침울한','우울한','지루한','지친','식상한','무덤덤한','힘든','피곤한']},
    // ],
    selectEmotion:{title:'ddd',color:'#E6E8EA',value:'감정찾기'},
    maxSelect:1,
    disabledNext:true,
    free: 'N',
    cmplt:false,
    ques:[],
    replyArr:[],
    replyObjArr:[],
    userReplyNo:[],
    userReply:[],
    emotionList: [],
    emotionTitleCd : 'SU008',
    emotionDetailCd : 'SU009',
    answer:[],
    emotionSelectList:[],
  }),
  computed:{
    bgColor(){
      return this.first ? '#7260FF': this.selectEmotion.color;
    }
  },
  components: {
    FooterBtnsNext,
    ThermometerIcon,
    EmotionSheet
  },
  watch: {
    answer(){
      this.sheetClose(this.answer[0])
    },
    emotionValue(){
      if(this.emotionValue > 0){
        this.disabledNext = false
      }else{
        this.disabledNext  = true
      }
    }
  },
  created () {
    this.getTravelEmotionList()
  },
  mounted(){
    setTimeout(() => this.getUnitDetailUse(), 100); // 저장한 이후
  },
  methods:{
    async getTravelEmotionList () {
         await store.dispatch('getTravelEmotionList', this.$_payload('so',[
               {'emotionTitleCd':this.emotionTitleCd},
               {'emotionDetailCd':this.emotionDetailCd}
             ]))
             .then(res => {
             if (res.success) {
                 this.emotionList = res.data;
                 // this.getStepLoadData();
             } else {
                 console.log(res.msg)
                 this.emotionList = []
             }
             })
             .catch(error => {
             console.error(error)
             this.emotionList = []
             })
             .finally(() => {})
    },
    async getUnitDetailUse() {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn
      // this.cmplt = true
      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo':this.unitDtlUseNo[this.current-1]},
            {'unitDtlPageSeq':this.unitDtlPageSeq[this.current-1]},
            {'freeYn':this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
          .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl,i) => {

              // 질문 셋팅
              // this.ques[i] = quesEl.ques
              this.ques.push(quesEl.ques)
              this.maxSelect = quesEl.selectCnt

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                this.replyArr.push(replyEl.reply)
                this.replyObjArr.push(replyEl)
              });

              // // 유저 답변 셋팅
              if(quesEl.memberUnitDtlReplyList.length > 0){
                quesEl.memberUnitDtlReplyList.forEach((userReplyEl,j) => {
                  this.userReplyNo[i+j] = userReplyEl.memberUnitDtlReplyUseNo
                  this.answer.push(userReplyEl.reply)
                  this.emotionValue = userReplyEl.score
                  this.emotionSelectList.push(userReplyEl.reply)
                });
              }
            });

          } else {
              console.log(res.msg)
              // this.answer = [];
          }
          })
          .catch(error => {
              console.error(error)
              // this.answer = [];
          })
          .finally(() => {})
    },
    async setMemberReply () {

      if(!this.cmplt){ // 완료상태가 아닐때만 저장
        // 유저 답변 셋팅
        let replyObj = this.replyObjArr[0]
        this.emotionSelectList.forEach((val,i) => {

          this.userReply[i] = {
                                unitId: replyObj.unitId,
                                sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,
                                memberUnitDtlReplyUseNo: 0,
                                // unitUseNo: replyObj.unitUseNo,
                                unitNo: replyObj.unitNo,
                                // unitDtlUseNo: replyObj.unitDtlUseNo,
                                unitDtlNo: replyObj.unitDtlNo,
                                // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
                                unitDtlQuesNo: replyObj.unitDtlQuesNo,
                                // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
                                unitDtlReplyNo: replyObj.unitDtlReplyNo,
                                userKey: this.$store.state.auth.authUser.userKey,
                                reply: val,
                                score: this.emotionValue,
                                freeYn: this.free,
                                unitType:"03",
                              }
        })
        await store.dispatch('setMemberReply', this.$_payload('memberReplyList',this.userReply))
              .then(res => {
                if (res.success) {
                  setTimeout(() => this.$emit('next'), 500); // 저장한 이후
                } else {
                    console.log(res.msg)
                }
              })
              .catch(error => {
                console.error(error)
              })
              .finally(() => {
              })
      } else {
        this.$emit('next')
      }
    },
    reset(){
      if(!this.cmplt){
        this.emotionValue=0;
      }
    },
    emotionSelected(emotionSelected){
      if(!this.cmplt){
        this.emotionSelectList = emotionSelected
      }
    },
    sheetClose(value){

      if(value == undefined){
        this.sheet = false
      }else{
        this.sheet = false
        this.first = false
        // this.disabledNext = false

        this.emotionList.forEach((highCode) => {
          highCode.detailCodeList.forEach((code) => {
            if(code.cd == value){
              this.selectEmotion.title = highCode.cdNm
              this.selectEmotion.color = highCode.descCont
              this.selectEmotion.value = code.cdNm
            }

          })
        })
      }
    }
  }
};
</script>
